export default "__VITE_ASSET__a51e0362__"